export enum UserRoleType {
    USER = 'user',
    ADMIN = 'admin'
}